var path = '/static/assets/khapps/fms_app/partials/manage/sharing/sharing_landing.html';
var html = "<div id=\"pulse-container\"></div>\n<kh-card cards=\"SharingCards\"></kh-card>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;